import { Queue, QueuePayload, QueueResponse } from 'lib-shared-legacy-types';

import { ajaxSend } from '../../../api/api';

const v2BasePath = '/v2/queues';
const v3BasePath = '/v3/queues';

export interface QueuesQueryParams {
  search?: string;
  offset?: number;
  limit?: number;
  sort_by?: string;
  is_archived?: boolean;
}

export interface QueuesGetItemsResponse {
  data: {
    queues: Array<Queue>;
  };
  meta: {
    next_page: string | null;
    prev_page: string | null;
  };
}

export function getQueues(params: QueuesQueryParams = {}) {
  return ajaxSend<QueuesGetItemsResponse>({
    path: v3BasePath,
    params: params as any,
  });
}

export function getQueue(queueId: string): Promise<QueueResponse> {
  return ajaxSend({
    path: `${v2BasePath}/${queueId}`,
  });
}

export function createQueue(data: QueuePayload): Promise<QueueResponse> {
  return ajaxSend({
    method: 'POST',
    path: `${v2BasePath}`,
    data,
  });
}

export function updateQueue(
  queueId: string,
  data: QueuePayload,
): Promise<QueueResponse> {
  return ajaxSend({
    method: 'PATCH',
    path: `${v2BasePath}/${queueId}`,
    data,
  });
}
